import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InnerSidebarComponent, NavbarComponent, NavbarRoutesComponent, PageHeaderComponent } from './components';
import { PaginationComponent } from './components/pagination/pagination.component';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { UsersComponent } from './components/users/users.component';
import { RoleManagementComponent } from './components/role-management/role-management.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ViewRolesComponent } from './components/view-roles/view-roles.component';
import { CommonsModule, ModalsModule, SidedrawerModule } from '@increff/commons';
import { TemplateInfoComponent } from './components/template-info/template-info.component';
import { AuditLogComponent } from './components/audit-log/audit-log.component';
/**
 * Holds all the common components, services, directives and pipes
 */

const DECLARED_COMPONENTS = [
    NavbarComponent,
    NavbarRoutesComponent,
    InnerSidebarComponent,
    PageHeaderComponent,
    PaginationComponent,
    UsersComponent,
    RoleManagementComponent,
    ViewRolesComponent,
    TemplateInfoComponent,
    LogoutComponent,
    AuditLogComponent
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        CommonsModule.forRoot(),
        ModalsModule,
        SidedrawerModule,
        FilterPipeModule
    ],
    declarations: [
        ...DECLARED_COMPONENTS
    ],
    providers: [
    ],
    exports: [
        ...DECLARED_COMPONENTS,
        CommonsModule,
        ModalsModule,
        SidedrawerModule,
        FilterPipeModule
    ]
})
export class SharedModule { }
